import { NgModule } from '@angular/core';
import { ZerExampleLibComponent } from './zer-example-lib.component';

@NgModule({
  declarations: [ZerExampleLibComponent],
  imports: [
  ],
  exports: [ZerExampleLibComponent]
})
export class ZerExampleLibModule { }
